import { Close } from "@mui/icons-material";
import { Box, Dialog, DialogContent, DialogTitle, Divider, IconButton, Skeleton, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { DIALOG_MAX_WIDTHS } from "src/Components/Common/Modal/ModalWidth";
import { formatDateTime24Hours } from "src/Utils/DateUtils";

import useFetch from "src/Components/Common/useFetch";
import arrow_right from "src/Graphics/AutomatedRecon/arrow_right.svg";
import { API_ENDPOINTS } from "src/Utils/ApiConstants/ApiUrlConstants";

export enum INVOICE_HISTORY_FIELD {
  Issue = "Issue",
  Maker = "Maker",
  Apporver = "Approver",
  Checker = "Checker",
  Attachment = "Attachment",
  Comment = "Comment",
  SubmittedDetails = "Submitted Details",
  Priority = "Priority",
  IssuCategory = "Issue Category",
  Viniculum = "Viniculum",
}
export enum INVOICE_HISTORY_ACTION {
  Created = "Created",
  AutoAssigned = "Auto Assigned",
  Updated = "Updated",
  Uploaded = "Uploaded",
  Added = "Added",
  Rejected = "Rejected",
  Approved = "Approved",
  Closed = "Closed",
  Reopened = "Re-opened",
}

const HistoryOfRejectedInvoices = ({
  openHistoryOfRejectedInvoices,
  setOpenHistoryOfRejectedInvoices,
  selectedRowForHistory,
  role,
}) => {
  const [invoiceHistoryList, setInvoiceHistoryList] = useState([]);
  const [loadingInvoiceHistory, setLoadingInvoiceHistory] = useState<boolean>(false);

  useEffect(() => {
    listHistory();
  }, []);
  const listHistory = () => {
    setLoadingInvoiceHistory(true);
    useFetch(API_ENDPOINTS.LIST_HISTORY(role, selectedRowForHistory?.grnNumber).url, "GET", {
      failureMessage: API_ENDPOINTS.LIST_HISTORY(role, selectedRowForHistory?.grnNumber).failureMessage,
      thenCallBack: (response) => {
        setInvoiceHistoryList(response.data?.history || []);
        setLoadingInvoiceHistory(false);
      },
    });
  };

  const handleClose = () => {
    setOpenHistoryOfRejectedInvoices(false);
    // Reset any state if needed
  };
  return (
    <div>
      <Dialog open={openHistoryOfRejectedInvoices} maxWidth={DIALOG_MAX_WIDTHS.SM} fullWidth>
        <DialogTitle className="dialog-title">
          <div className="heading-m">History for {selectedRowForHistory.vendorName}</div>
          <div className="vertical_center_align">
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 2 }}>
          {loadingInvoiceHistory ? (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Skeleton variant="rounded" width="100%" height={40} />
              <Skeleton variant="rounded" width="100%" height={40} />
              <Skeleton variant="rounded" width="100%" height={40} />
              <Skeleton variant="rounded" width="100%" height={40} />
            </Box>
          ) : (
            invoiceHistoryList.map((item: any, index) => {
              let actionType = "";
              // if (item.actionOwner === ActorTypesForRecon.ReconUser) {
              if (item.action === INVOICE_HISTORY_ACTION.Created) actionType = "Created";
              if (item.action === INVOICE_HISTORY_ACTION.AutoAssigned) actionType = "Auto assigned";
              if (item.action === INVOICE_HISTORY_ACTION.Updated) actionType = "Updated the";
              if (item.action === INVOICE_HISTORY_ACTION.Uploaded) actionType = "Uploaded the";
              if (item.action === INVOICE_HISTORY_ACTION.Added) actionType = "Added";
              if (item.action === INVOICE_HISTORY_ACTION.Rejected) actionType = "Rejected the";
              if (item.action === INVOICE_HISTORY_ACTION.Approved) actionType = "Approved the";
              if (item.action === INVOICE_HISTORY_ACTION.Closed) actionType = "Closed";
              if (item.action === INVOICE_HISTORY_ACTION.Reopened) actionType = "Re-opened";
              if (item.action === INVOICE_HISTORY_ACTION.Updated && item.field === INVOICE_HISTORY_FIELD.Viniculum)
                actionType = "marked as Updated in";

              // } else if (item.actionOwner === ActorTypesForRecon.Partner) {
              //   if (item.action === INVOICE_HISTORY_ACTION.Raised) actionType = "Query raised by";
              //   if (item.action === INVOICE_HISTORY_ACTION.Received) actionType = "Response received by";
              //   if (item.action === INVOICE_HISTORY_ACTION.Updated) actionType = "Response updated by";
              // }

              return (
                <Box key={index}>
                  <Box sx={{ paddingY: 1 }}>
                    {/* this is for the first row of the history item
                    e.g. Mukul deleted the Attachment
                    e.g. Mukul updated the Due Date
                    e.g. Mukul created the task
                     */}
                    <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                      {/* {item.actionOwner === ActorTypesForRecon.ReconUser ? ( */}
                      <p>
                        {item.action === INVOICE_HISTORY_ACTION.Created ? (
                          <span className="fs_14 fw_600">{`${item.field} ${actionType}`}</span>
                        ) : item.action === INVOICE_HISTORY_ACTION.Closed ||
                          item.action === INVOICE_HISTORY_ACTION.Reopened ? (
                          <span className="fs_14 fw_600">{`${item.field} ${actionType}`}</span>
                        ) : item.action === INVOICE_HISTORY_ACTION.AutoAssigned ? (
                          <span className="fs_14 fw_600">{`${actionType} ${item.field}`}</span>
                        ) : (
                          <>
                            <span className="fs_14 fw_600">
                              {item.field === INVOICE_HISTORY_FIELD.IssuCategory ? "" : item.actionOwner}
                            </span>
                            <span className="fs_14"> {actionType} </span>
                            <span className="fs_14 fw_600">{item.field}</span>
                          </>
                        )}
                        {/* <span className="fs_14 fw_600">{item.actionOwner}</span>
                          <span className="fs_14"> {actionType} </span>
                          <span className="fs_14 fw_600">{item.field}</span>
                          <span className="fs_14">
                            {item.action === INVOICE_HISTORY_ACTION.Created ||
                            item.action === INVOICE_HISTORY_ACTION.Moved ||
                            item.action === INVOICE_HISTORY_ACTION.ClosedAndReset ||
                            item.action === INVOICE_HISTORY_ACTION.Approved ||
                            item.action === INVOICE_HISTORY_ACTION.Resolved ||
                            item.action === INVOICE_HISTORY_ACTION.Sent
                              ? ""
                              : item.field}
                          </span> */}
                      </p>
                      {/* // ) : (
                      //   <p>
                      //     <span className="fs_14"> {actionType} </span>
                      //     <span className="fs_14 fw_600">{props.businessPartnerName}</span>
                      //   </p>
                      // )} */}
                      <Typography variant="subtitle2" sx={{ fontWeight: "400", color: "rgba(0, 0, 0, 0.6)" }}>
                        {formatDateTime24Hours(item.timestamp)}{" "}
                      </Typography>
                    </Box>
                    {/* this is for the second row of the history item*/}
                    {item.field === INVOICE_HISTORY_FIELD.Attachment ||
                    item.field === INVOICE_HISTORY_FIELD.Issue ||
                    item.field === INVOICE_HISTORY_FIELD.Comment ||
                    item.action === INVOICE_HISTORY_ACTION.Rejected ? (
                      <Box sx={{ display: "flex", flexDirection: "row" }}>
                        <Typography
                          variant="subtitle2"
                          sx={{
                            fontWeight: "400",
                            fontSize: "12px",
                            color: "rgba(0, 0, 0, 0.6)",
                            alignSelf: "center",
                            wordBreak: "break-word",
                          }}
                        >
                          {item.action === INVOICE_HISTORY_ACTION.Reopened
                            ? "Status restored to: "
                            : item.field === INVOICE_HISTORY_FIELD.Attachment
                            ? "Filename: "
                            : item.field === INVOICE_HISTORY_FIELD.Issue
                            ? "Vendor Name: "
                            : item.field === INVOICE_HISTORY_FIELD.Comment
                            ? "Comment: "
                            : item.action === INVOICE_HISTORY_ACTION.Rejected
                            ? "Rejection Reason: "
                            : ""}
                        </Typography>
                        <Typography
                          variant="subtitle2"
                          sx={{
                            marginLeft: 1,
                            fontWeight: "400",
                            fontSize: "12px",
                            alignSelf: "center",
                            wordBreak: "break-word",
                          }}
                        >
                          {item.action !== INVOICE_HISTORY_ACTION.Reopened && item.field === INVOICE_HISTORY_FIELD.Issue
                            ? selectedRowForHistory.vendorName
                            : item.newValue}
                        </Typography>
                      </Box>
                    ) : item.field === INVOICE_HISTORY_FIELD.Priority ||
                      [
                        INVOICE_HISTORY_FIELD.Apporver,
                        INVOICE_HISTORY_FIELD.Checker,
                        INVOICE_HISTORY_FIELD.Maker,
                        INVOICE_HISTORY_FIELD.IssuCategory,
                      ].includes(item.field) ? (
                      <Box sx={{ display: "flex", flexDirection: "row" }}>
                        {item.oldValue && (
                          <>
                            <Typography
                              variant="subtitle2"
                              sx={{
                                marginRight: 1,
                                fontWeight: "400",
                                fontSize: "12px",
                                color: "rgba(0, 0, 0, 0.6)",
                                alignSelf: "center",
                                wordBreak: "break-word",
                              }}
                            >
                              {item.oldValue || ""}
                            </Typography>
                            <img src={arrow_right} alt="arrow icon" />
                          </>
                        )}

                        <Typography
                          variant="subtitle2"
                          sx={{
                            marginLeft: 1,
                            fontWeight: "400",
                            fontSize: "12px",
                            alignSelf: "center",
                            wordBreak: "break-word",
                          }}
                        >
                          {item.newValue || ""}
                        </Typography>
                      </Box>
                    ) : null}
                  </Box>
                  <Divider />
                </Box>
              );
            })
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default HistoryOfRejectedInvoices;
